import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { currentTable } from "../../../../app/viewManager.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { validateData, getContent, removeStaleRow, deleteRecord } from "./tableManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { teamActivities } from "../../../../app/utils/enums.js";

function sortByName() { currentTable.setSort("name", "asc"); }

function formatTeam(team) {
    const permissions = team.permissions ?? [];
    const activityIds = team.activityIds ?? [];
    return {
        id: team.id,
        name: team.name,
        permissionId: permissions.map(permission => permission.id).join("; ") + (permissions.length ? ";" : ""),
        permissionName: permissions.map(permission => permission.name).join("; ") + (permissions.length ? ";" : ""),
        activityId: activityIds.join("; ") + (activityIds.length ? ";" : ""),
        activityName: activityIds.map(id => teamActivities[id]).filter(Boolean).join("; ") + (activityIds.length ? ";" : "")
    };
}

export async function loadTeams() {
    const teams = await apiFetch("teams");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(teams)) { currentTable.replaceData([]); return; }

    currentTable.setData(teams.map(formatTeam));
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
}

async function collectData() {
    const content = getContent();
    if (!content) return null;

    return {
        Name:          content.querySelector("#inputTeamName")?.getValue?.()     ?? "",
        PermissionIds: content.querySelector("#dropdownPermission")?.getValue?.() ?? [],
        ActivityIds:   content.querySelector("#dropdownActivity")?.getValue?.()   ?? [],
    };
}

export async function createTeam() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newTeam = await apiFetch("teams", "POST", {
        Name: collectedData.Name,
        PermissionIds: collectedData.PermissionIds,
        ActivityIds: collectedData.ActivityIds
    });
    if (isErrorResult(newTeam)) return newTeam ? true : undefined;

    await currentTable.addRow(formatTeam(newTeam), true);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Team erfolgreich hinzugefügt!", "success");
    return newTeam;
}

export async function updateTeam(teamId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedTeam = await apiFetch(`teams/${teamId}`, "PATCH", {
        Name: collectedData.Name,
        PermissionIds: collectedData.PermissionIds,
        ActivityIds: collectedData.ActivityIds
    });
    if (removeStaleRow(updatedTeam, teamId)) return;
    if (isErrorResult(updatedTeam)) return updatedTeam ? true : undefined;

    await currentTable.updateOrAddData([formatTeam(updatedTeam)]);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Team erfolgreich aktualisiert!", "success");
    return updatedTeam;
}

export const deleteTeam = (teamId) => deleteRecord("teams", teamId, "Team erfolgreich gelöscht!");
